import { render, staticRenderFns } from "./Hugescoretable.vue?vue&type=template&id=ca7887d2&"
import script from "./Hugescoretable.vue?vue&type=script&lang=js&"
export * from "./Hugescoretable.vue?vue&type=script&lang=js&"
import style0 from "./Hugescoretable.vue?vue&type=style&index=0&id=ca7887d2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7887d2')) {
      api.createRecord('ca7887d2', component.options)
    } else {
      api.reload('ca7887d2', component.options)
    }
    module.hot.accept("./Hugescoretable.vue?vue&type=template&id=ca7887d2&", function () {
      api.rerender('ca7887d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Hugescoretable.vue"
export default component.exports